import format from '@/module/util/format'

export default {
	props: {
		id: {
			type: String,
			required: true
		},
		event: {
			type: Array,
			required: true
		}
	},

	methods: {
		...format
	}
}
